// react
import React from "react";

// react-i18next
import { useTranslation } from "react-i18next";

// @mui
import { useTheme } from "@mui/material";

// A ---------------------------------------------------------------------- M

const CustomTooltip = ({ active, payload }) => {
  console.log(payload);
  const { t } = useTranslation();
  const theme = useTheme();

  if (!active || !payload || payload.length === 0) return null;

  const point = payload[0];
  const date = new Date(point.payload.time);

  return (
    <div
      style={{
        background: theme.palette.background.paper,
        padding: "10px 14px",
        borderRadius: 8,
        color: theme.palette.text.primary,
        fontSize: "0.85rem",
        boxShadow: theme.shadows[4],
        border: `1px solid ${theme.palette.divider}`,
        maxWidth: 220,
      }}
    >
      <div style={{ fontWeight: 600 }}>{point.name}</div>

      <div style={{ marginTop: 4 }}>
        {t("value")}: <strong>{point.value}</strong>
      </div>

      <div style={{ opacity: 0.6, marginTop: 4, fontSize: "0.78rem" }}>{date.toLocaleString()}</div>
    </div>
  );
};

export default CustomTooltip;
